import { Component, Input } from '@angular/core';
import { UrlConfig } from '@modules/admin/interfaces/admin-url.interface';
import { CommonModule } from '@angular/common';

/**
 * FooterHelpComponent is responsible for displaying help-related links in the footer.
 * It retrieves help links from a service and displays them dynamically.
 */
@Component({
  selector: 'footer-help',
  templateUrl: './footer-help.component.html',
  styles: [':host { display: contents}'],
  standalone: true,
  imports: [CommonModule],
})
export class FooterHelpComponent {
  /** Stores the list of help links to be displayed in the footer. */
  @Input() urlConfigData: UrlConfig[] = [];
}
